
/* ─────────────────────────────────────────────
   CAMERA / BARCODE SCANNER
───────────────────────────────────────────── */
let _vinScanStream   = null; // MediaStream reference
let _vinScanDetector = null; // BarcodeDetector reference
let _vinScanRAF      = null; // requestAnimationFrame id
let _vinScanHandled  = false;

/* ─────────────────────────────────────────────
VIN SCANNER USING html5-qrcode (FIXED VERSION)
───────────────────────────────────────────── */
let html5QrCodeScanner = null;
let vinScanHandledRef = false;
let isScannerRunning = false;

function openVinScanner() {
  console.log('Opening VIN scanner...');
  vinScanHandledRef = false;
  isScannerRunning = false;
  state.vinScannerOpen = true;
  patchContent();
  
  setTimeout(() => {
    initHtml5QrCodeScanner();
  }, 300);
}

async function closeVinScanner() {
  console.log('Closing VIN scanner...');
  
  try {
    if (html5QrCodeScanner && isScannerRunning) {
      console.log('Stopping scanner...');
      await html5QrCodeScanner.stop();
      console.log('Scanner stopped');
      isScannerRunning = false;
    }
    
    if (html5QrCodeScanner) {
      console.log('Clearing scanner...');
      await html5QrCodeScanner.clear();
      console.log('Scanner cleared');
      html5QrCodeScanner = null;
    }
  } catch (err) {
    console.error('Scanner cleanup error:', err);
    html5QrCodeScanner = null;
    isScannerRunning = false;
  }
  
  state.vinScannerOpen = false;
  patchContent();
}

async function initHtml5QrCodeScanner() {
  const container = document.getElementById('vin-scanner-container');
  if (!container) {
    console.error('Scanner container not found');
    return;
  }
  
  try {
    if (html5QrCodeScanner) {
      console.log('Cleaning up existing scanner...');
      if (isScannerRunning) {
        await html5QrCodeScanner.stop();
      }
      await html5QrCodeScanner.clear();
      html5QrCodeScanner = null;
      isScannerRunning = false;
    }
    
    html5QrCodeScanner = new Html5Qrcode('vin-scanner-container');
    console.log('Scanner instance created');
    
const config = {

  fps: 20,
 
  qrbox: {

    width: 350,

    height: 140

  },
 
  aspectRatio: 1.777778,

  disableFlip: false,

  rememberLastUsedCamera: true,
 
  formatsToSupport: [

    Html5QrcodeSupportedFormats.CODE_39,

    Html5QrcodeSupportedFormats.CODE_128,

    Html5QrcodeSupportedFormats.PDF_417,

    Html5QrcodeSupportedFormats.DATA_MATRIX,

    Html5QrcodeSupportedFormats.QR_CODE

  ]

};
 
    await html5QrCodeScanner.start(
      { facingMode: 'environment' },
      config,
      onVinCodeScanned,
      onScanError
    );
    
    isScannerRunning = true;
    const video = document.querySelector('#vin-scanner-container video');

if (video) {

  const track = video.srcObject?.getVideoTracks?.()[0];

  const capabilities = track?.getCapabilities?.();

  if (capabilities?.zoom) {

    track.applyConstraints({
      advanced: [{ zoom: 2 }]
    });
  }
}
    console.log('Scanner started successfully');
    
  } catch (err) {
    console.error('Scanner init error:', err);
    isScannerRunning = false;
    html5QrCodeScanner = null;
    
    if (err.name === 'NotAllowedError') {
      showToast('Camera permission denied. Please enable camera access.');
    } else if (err.name === 'NotFoundError') {
      showToast('No camera found on this device.');
    } else if (err.name === 'NotReadableError') {
      showToast('Camera is being used by another application.');
    } else {
      showToast('Camera error: ' + err.message);
    }
    
    setTimeout(() => {
      state.vinScannerOpen = false;
      patchContent();
    }, 2000);
  }
}

function onVinCodeScanned(decodedText, decodedResult) {

  if (vinScanHandledRef === true) return;

  console.log('RAW SCAN:', decodedText);
  let cleaned = String(decodedText)
    .replace(/\*/g, '') // remove CODE39 stars
    .replace(/[^A-Z0-9]/gi, '') // keep only VIN chars
    .toUpperCase()
    .trim();

  console.log('CLEANED:', cleaned);

  // EXTRACT 17 CHAR VIN
  if (cleaned.length > 17) {
    const match = cleaned.match(/[A-HJ-NPR-Z0-9]{17}/);

    if (match) {
      cleaned = match[0];
    }
  }

  console.log('FINAL VIN:', cleaned);

  const vin = normalizeVin(cleaned);

  if (!vin) {
    console.log('INVALID VIN');
    return;
  }

  vinScanHandledRef = true;

  console.log('VALID VIN FOUND:', vin);

  closeVinScanner().then(() => {

    state.vinInput = vin;

    showToast('VIN scanned successfully');

    patchContent();

    setTimeout(() => {
      decodeVin(vin);
    }, 300);

  }).catch(err => {
    console.error(err);
    vinScanHandledRef = false;
  });
}

function onScanError(errorMessage) {
  // Silently ignore scan errors
}
const VIN_API_URL = "https://api.exhaustexpert.com/python-vin/decode-vin";
//  const VIN_API_TOKEN ="";
// const VIN_API_URL = "https://piyushvs-vin.hf.space/decode-vin";
// const VIN_API_TOKEN = "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"; 

let vinApiBusy = false;

async function captureVinFrameForOCR() {
  if (vinApiBusy) return;

  const video = document.querySelector('#vin-scanner-container video');
  if (!video || !video.videoWidth || !video.videoHeight) {
    showToast('Camera not ready. Wait a moment and try again.');
    return;
  }

  vinApiBusy = true;
  showToast('Scanning VIN…');

  try {
    // Capture current camera frame
    const canvas = document.createElement('canvas');
    canvas.width  = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0);

    const blob = await new Promise(res => canvas.toBlob(res, 'image/jpeg', 0.97));
    if (!blob) throw new Error('Could not capture camera frame.');

    // Send to your API as multipart form-data
    const formData = new FormData();
    formData.append('file', blob, 'vin-capture.jpg');

    const res = await fetch(VIN_API_URL, {
      method: 'POST',
      body: formData
    });

    const raw = await res.text();
    console.log('=== API STATUS ===', res.status);
    console.log('=== API RAW RESPONSE ===', raw);

    if (!res.ok) {
      throw new Error(`API error ${res.status}: ${raw}`);
    }

    // Parse response — handle all possible field names
    let data = {};
    try { data = JSON.parse(raw); } catch(e) {}

    console.log('=== API PARSED ===', data);

    const rawVin = data.vin || data.VIN || data.vehicle_id 
                || data.vinNumber || data.vin_number 
                || data.result || '';

    const vin = normalizeVin(String(rawVin));

    if (!vin) {
      throw new Error('No valid VIN in response. Check console for API response.');
    }

    await closeVinScanner();
    state.vinInput = vin;
    state.vinError = '';
    state.vinDecodeError = '';
    patchContent();
    showToast(`VIN scanned: ${vin}`);
    setTimeout(() => decodeVin(vin), 300);

  } catch (err) {
    console.error('VIN API scan error:', err);
    state.vinError = err.message || 'VIN scan failed. Try again.';
    patchContent();
    showToast(state.vinError);
  } finally {
    vinApiBusy = false;
  }
}

function sharpenGrey(grey, w, h) {
  const out = new Float32Array(grey.length);
  const K   = 0.6; // sharpening strength (0 = none, 1 = full)

  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const idx = y * w + x;

      // 3×3 neighbourhood with clamped edges
      const tl = grey[Math.max(y-1,0)*w + Math.max(x-1,0)];
      const tc = grey[Math.max(y-1,0)*w + x];
      const tr = grey[Math.max(y-1,0)*w + Math.min(x+1,w-1)];
      const ml = grey[y*w + Math.max(x-1,0)];
      const mc = grey[idx];
      const mr = grey[y*w + Math.min(x+1,w-1)];
      const bl = grey[Math.min(y+1,h-1)*w + Math.max(x-1,0)];
      const bc = grey[Math.min(y+1,h-1)*w + x];
      const br = grey[Math.min(y+1,h-1)*w + Math.min(x+1,w-1)];

      // Laplacian high-pass
      const lap = 8*mc - tl - tc - tr - ml - mr - bl - bc - br;
      out[idx] = mc + K * lap;
    }
  }
  return out;
}


function buildVinTextOnlyCanvases(video) {
  const vw = video.videoWidth;
  const vh = video.videoHeight;

  const crops = [
    { x: 0.08, y: 0.34, w: 0.84, h: 0.12 },
    { x: 0.08, y: 0.28, w: 0.84, h: 0.12 },
    { x: 0.08, y: 0.40, w: 0.84, h: 0.12 },
    { x: 0.05, y: 0.30, w: 0.90, h: 0.18 }
  ];

  const canvases = [];

  for (const crop of crops) {
    const sx = Math.floor(vw * crop.x);
    const sy = Math.floor(vh * crop.y);
    const sw = Math.floor(vw * crop.w);
    const sh = Math.floor(vh * crop.h);

    canvases.push(makeVinCanvas(video, sx, sy, sw, sh, 'threshold'));
    canvases.push(makeVinCanvas(video, sx, sy, sw, sh, 'grayscale'));
  }

  return canvases;
}

function makeVinCanvas(video, sx, sy, sw, sh, mode) {
  const scale = 5;

  const canvas = document.createElement('canvas');
  canvas.width = sw * scale;
  canvas.height = sh * scale;

  const ctx = canvas.getContext('2d', { willReadFrequently: true });

  ctx.imageSmoothingEnabled = false;

  ctx.drawImage(
    video,
    sx,
    sy,
    sw,
    sh,
    0,
    0,
    canvas.width,
    canvas.height
  );

  const img = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = img.data;

  for (let i = 0; i < data.length; i += 4) {
    let gray = data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;

    // Boost contrast
    gray = ((gray - 128) * 2.2) + 128;
    gray = Math.max(0, Math.min(255, gray));

    let value = gray;

    if (mode === 'threshold') {
      value = gray > 120 ? 255 : 0;
    }

    data[i] = value;
    data[i + 1] = value;
    data[i + 2] = value;
  }

  ctx.putImageData(img, 0, 0);

  return canvas;
}

function extractStrictVin(text) {
  if (!text) return null;

  const raw = String(text).toUpperCase();

  console.log('RAW OCR:', raw);

  const cleaned = raw
    .replace(/VIN/g, '')
    .replace(/NUMBER/g, '')
    .replace(/[^A-Z0-9]/g, '');

  console.log('CLEANED OCR:', cleaned);

  const candidates = [];

  // Try exact 17-character windows
  for (let i = 0; i <= cleaned.length - 17; i++) {
    candidates.push(cleaned.slice(i, i + 17));
  }

  // Try OCR correction version
  const corrected = cleaned
    .replace(/O/g, '0')
    .replace(/Q/g, '0')
    .replace(/I/g, '1');

  for (let i = 0; i <= corrected.length - 17; i++) {
    candidates.push(corrected.slice(i, i + 17));
  }

  console.log('VIN CANDIDATES:', candidates);

  for (const c of candidates) {
    const vin = normalizeVin(c);
    if (vin) return vin;
  }

  return null;
}
function buildVinOcrCanvases(video) {
  const vw = video.videoWidth;
  const vh = video.videoHeight;
  // Target the TEXT ROW below the barcode, not the bars themselves
  const crops = [
    { x: 0.02, y: 0.58, w: 0.96, h: 0.22 },
    { x: 0.02, y: 0.50, w: 0.96, h: 0.30 },
    { x: 0.02, y: 0.65, w: 0.96, h: 0.20 },
  ];
  const canvases = [];
  for (const crop of crops) {
    const sx = Math.round(vw * crop.x), sy = Math.round(vh * crop.y);
    const sw = Math.round(vw * crop.w), sh = Math.round(vh * crop.h);
    canvases.push(makeVinOcrCanvas(video, sx, sy, sw, sh, 'normal'));
    canvases.push(makeVinOcrCanvas(video, sx, sy, sw, sh, 'inverted'));
    canvases.push(makeVinOcrCanvas(video, sx, sy, sw, sh, 'soft-threshold'));
  }
  return canvases;
}


function makeVinOcrCanvas(video, sx, sy, sw, sh, mode) {
  const SCALE = 4;
  const cw = sw * SCALE;
  const ch = sh * SCALE;

  const canvas = document.createElement('canvas');
  canvas.width  = cw;
  canvas.height = ch;

  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(video, sx, sy, sw, sh, 0, 0, cw, ch);

  const img  = ctx.getImageData(0, 0, cw, ch);
  const data = img.data;
  const len  = data.length;

  // ── Step 1: convert to greyscale ──
  const grey = new Float32Array(cw * ch);
  for (let i = 0, p = 0; i < len; i += 4, p++) {
    grey[p] = data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;
  }

  // ── Step 2: unsharp mask (sharpens edges for OCR) ──
  const sharp = sharpenGrey(grey, cw, ch);

  // ── Step 3: contrast stretch to 0–255 ──
  let lo = 255, hi = 0;
  for (let p = 0; p < sharp.length; p++) {
    if (sharp[p] < lo) lo = sharp[p];
    if (sharp[p] > hi) hi = sharp[p];
  }
  const range = hi - lo || 1;

  for (let p = 0, i = 0; p < sharp.length; p++, i += 4) {
    let v = ((sharp[p] - lo) / range) * 255;

    if (mode === 'soft-threshold') {
      // Sigmoid curve: keeps anti-aliasing, pushes towards black/white
      v = 255 / (1 + Math.exp(-(v - 128) / 20));
    } else if (mode === 'inverted') {
      v = 255 - v;
    }
    // mode === 'normal': use v as-is

    v = Math.round(Math.max(0, Math.min(255, v)));
    data[i] = data[i + 1] = data[i + 2] = v;
    data[i + 3] = 255;
  }
const sum = data.reduce((acc, v, i) => i % 4 === 0 ? acc + v : acc, 0);
const avgBrightness = sum / (data.length / 4);
if (avgBrightness < 110) { // dark label — invert
  for (let i = 0; i < data.length; i += 4) {
    data[i] = 255 - data[i];
    data[i+1] = 255 - data[i+1];
    data[i+2] = 255 - data[i+2];
  }
}
  ctx.putImageData(img, 0, 0);
  return canvas;
}

function extractValidVinOnly(rawText) {
  if (!rawText) return null;
  const base = rawText.toUpperCase().replace(/[^A-Z0-9]/g, '');
  const corrections = [
    s => s,
    s => s.replace(/[OQ]/g,'0').replace(/[ILJ]/g,'1').replace(/B/g,'8')
           .replace(/E/g,'3').replace(/S/g,'5').replace(/Z/g,'2').replace(/U/g,'0'),
    s => s.replace(/[OQ]/g,'0').replace(/[ILJ]/g,'1').replace(/B/g,'6')
           .replace(/[SZ]/g,'2'),
  ];
  for (const fix of corrections) {
    const s = fix(base);
    for (let i = 0; i <= s.length - 17; i++) {
      const vin = normalizeVin(s.slice(i, i + 17));
      if (vin) return vin;
    }
  }
  return null;
}

function makePreprocessedCanvas(video, sx, sy, sw, sh, mode) {
  const scale = 4;

  const canvas = document.createElement('canvas');
  canvas.width = sw * scale;
  canvas.height = sh * scale;

  const ctx = canvas.getContext('2d', { willReadFrequently: true });

  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(
    video,
    sx,
    sy,
    sw,
    sh,
    0,
    0,
    canvas.width,
    canvas.height
  );

  const img = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = img.data;

  for (let i = 0; i < data.length; i += 4) {
    let gray = data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;

    // Increase contrast
    gray = ((gray - 128) * 1.8) + 128;
    gray = Math.max(0, Math.min(255, gray));

    let value = gray;

    if (mode === 'threshold') {
      value = gray > 135 ? 255 : 0;
    }

    if (mode === 'invert') {
      value = 255 - gray;
    }

    data[i] = value;
    data[i + 1] = value;
    data[i + 2] = value;
  }

  ctx.putImageData(img, 0, 0);

  return canvas;
}

function extractVinFromOcrText(text) {
  if (!text) return null;

  const raw = String(text).toUpperCase();

  console.log('RAW OCR TEXT:', raw);

  const lines = raw
    .split(/\n|\r/)
    .map(line => line.trim())
    .filter(Boolean);

  const candidates = [];

  for (const line of lines) {
    candidates.push(...makeVinCandidates(line));
  }

  // Also try entire OCR text as fallback
  candidates.push(...makeVinCandidates(raw));

  console.log('VIN CANDIDATES:', candidates);

  for (const candidate of candidates) {
    const vin = normalizeVin(candidate);
    if (vin) return vin;
  }

  return null;
}

function makeVinCandidates(input) {
  if (!input) return [];

  let s = String(input)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');

  const versions = new Set();

  versions.add(s);

  // OCR correction versions
  versions.add(
    s
      .replace(/O/g, '0')
      .replace(/Q/g, '0')
      .replace(/I/g, '1')
      .replace(/L/g, '1')
      .replace(/S/g, '5')
      .replace(/Z/g, '2')
      .replace(/B/g, '8')
  );

  versions.add(
    s
      .replace(/0/g, 'D')
      .replace(/1/g, 'T')
      .replace(/5/g, 'S')
      .replace(/8/g, 'B')
      .replace(/2/g, 'Z')
  );

  const candidates = [];

  for (const version of versions) {
    // Direct 17-character windows
    for (let i = 0; i <= version.length - 17; i++) {
      const part = version.slice(i, i + 17);
      if (/^[A-HJ-NPR-Z0-9]{17}$/.test(part)) {
        candidates.push(part);
      }
    }
  }

  return [...new Set(candidates)];
}
async function requestCameraPermission() {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
    stream.getTracks().forEach(track => track.stop());
    console.log('Camera permission granted');
    return true;
  } catch (err) {
    console.error('Camera permission error:', err);
    return false;
  }
}
